import React from 'react';

import PermissionsField from '~/components/AiAvailableResource/PermissionsField';
import ReferenceDataProvider from '~/utils/reference-data/context';

const AiAvailableResources = () => (
  <ReferenceDataProvider
    type="ReferenceAiAvailableResource"
    config={{
      customFields: {
        aiAvailableResourcePermissions: {
          component: PermissionsField,
          initialValue: [],
          normalizeValue: (v) => {
            const arr = Array.isArray(v) ? v : (v ? v.split(',') : []);
            return arr.map(p => ({ value: p, label: p }));
          },
          serializeValue: v => (Array.isArray(v) ? v.map(o => (typeof o === 'string' ? o : o.value)) : []),
        },
      },
    }}
  />
);

export default AiAvailableResources;
